import React, { useState, useEffect, useMemo } from 'react';
import Translations from '../../services/translation.service';
import Numbers from '../../services/numbers.service';
import User from '../../services/user.service';
import Plans from '../../services/plans.service';
import Storage from '../../services/storage.service';
import HTTP from '../../services/http.service';
import Summaries from '../../services/summaries.service';
import Helpers from '../../helpers/shared.helper';
import {
    resolveAmanFeatureAttributes,
    hasAmanFeatureSummaryAttributeData,
} from '../../helpers/aman-feature.helper';
import Data from "../../assets/img/stm-data.svg";
import Call from "../../assets/img/stm-call.svg";
import FirebaseAnalytics from '../../services/analytics.service';
import CONSTANTS from '../../services/constants.service';
import storefront from '../../services/storefront.service';
import Payments from '../../services/payments.service';
import * as variables from '../shared/variables';
import SpinnerTimeLoader from '../shared/timeLoading';
import StmSummaryAmanFeatureRows from '../shared/stm-summary-aman-feature-rows.component';
import EgyptFlexSummaryPlan from '../shared/egyptFlexSummaryPlan';

let prefix_general = "stm_general_";
const subscriptions = [];
const DropOffModal = (props) => {
    const [translationsKeys, setTranslationsKeys] = useState(Translations.keys ? Translations.keys : {});
    const [displayModal, setDisplayModal] = useState(true);
    const [reservedNumber, setReservedNumber] = useState(Storage.get("reserved_number") || Storage.get("reserved_number_local"));
    const [ setReservedNumberDetail] = useState({});
    const [loading, setLoading] = useState(true);
    const [, setFlag] = useState(false);
    const [summaryLoading, setSummaryLoading] = useState(null);
    const [savedPlans, setSavedPlans] = useState([]);
    const [savedPlanBundle, setSavedPlanBundle] = useState(null);
    const [planPromotions, setPlanPromotions] = useState([]);
    const [featureAttributes, setFeatureAttributes] = useState([]);
    const [isPaymentPending, setIsPaymentPending] = useState(true);
    const [planId, setPlanId] = useState(null);
    const [planDiscountedPrice, setPlanDiscountedPrice] = useState(null);
    const [planCode, setPlanCode] = useState("")
    const [planPrice, setPlanPrice] = useState(0);
    const [checkPaymentAuthentication, setCheckPaymentAuthentication] = useState(false);
    const [onboardingPaymentExpired, setOnboardingPaymentExpired] = useState(false);
    const [isMnp, setIsMnp] = useState(false);

    useEffect(() => {
        subscriptions.push(
            Translations.getKeysObsrv().subscribe(data => {
                setTranslationsKeys(data);
            })
        )

        return () => {
            if (subscriptions && subscriptions?.length) {
                for (let subscription of subscriptions) {
                    subscription.unsubscribe();
                }
            }
        }

    }, []);

    useEffect(() => {
        getNumber();
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    const getNumber = () => {
        setLoading(true);
        User.getFlowStatus()
            .then(response => {
                let flagData = response.data?.flow_status_flags;
                setFlag(flagData);
                if (flagData?.hasOwnProperty("PaymentPendingForonboarding")) {
                    setCheckPaymentAuthentication(flagData?.PaymentPendingForonboarding);
                }
                if (flagData?.hasOwnProperty("onboardingPaymentExpired")) {
                    setOnboardingPaymentExpired(flagData?.onboardingPaymentExpired);
                }
                if (flagData?.hasOwnProperty("IsMnp")) {
                    setIsMnp(flagData?.IsMnp);
                }
                subscriptions.push(
                    Storage.get_obsrv("vanity_details").subscribe(data => {
                        if (data) {
                            setIsPaymentPending(flagData?.PaymentPending)
                            if (flagData?.PaymentPending || flagData?.NumberPaymentPending) {
                                Numbers.postProcessReservedNumber()
                                    .then(response => {
                                        let getreservedNumber = Storage.get("reserved_number");
                                        setReservedNumber(Storage.get("reserved_number"))
                                        let proccessVanityNumber = Plans.proccessVanityNumberDataKW(getreservedNumber.VanityLevelId);
                                        setReservedNumberDetail({
                                            color: proccessVanityNumber.style_value,
                                            vanityName: proccessVanityNumber.nameKey,
                                            subname: proccessVanityNumber.subnameKey
                                        })
                                        setLoading(false)
                                    })
                                    .catch(err => {
                                        setLoading(false)
                                        logFirebaseErrorEvent(err)
                                    });
                            } else {
                                Numbers.postProcessCommitedNumber("2")
                                    .then(response => {
                                        setReservedNumber({
                                            "MSISDN": response?.data?.numbers[0].MSISDN
                                        });
                                        let proccessVanityNumber = Plans.proccessVanityNumberDataKW(
                                            response?.data?.numbers[0].VanityLevelId
                                        );
                                        setReservedNumberDetail({
                                            color: proccessVanityNumber.style_value,
                                            vanityName: proccessVanityNumber.nameKey,
                                            subname: proccessVanityNumber.subnameKey
                                        })
                                        setLoading(false)
                                    })
                                    .catch(err => {
                                        setLoading(false)
                                        logFirebaseErrorEvent(err)
                                    });
                            }
                        } else {
                            Storage.getOrfetch("vanity_details", Numbers.vanity_details)
                                .then(dataVanity => {
                                    if (dataVanity["data"]) {
                                        Numbers.process_vanity_details(dataVanity.data)
                                        setIsPaymentPending(flagData?.PaymentPending)
                                        if (flagData?.PaymentPending) {
                                            Numbers.postProcessReservedNumber()
                                                .then(response => {
                                                    let getreservedNumber = Storage.get("reserved_number");
                                                    setReservedNumber(Storage.get("reserved_number"))
                                                    let proccessVanityNumber = Plans.proccessVanityNumberDataKW(
                                                        getreservedNumber.VanityLevelId
                                                    );
                                                    setReservedNumberDetail({
                                                        color: proccessVanityNumber.style_value,
                                                        vanityName: proccessVanityNumber.nameKey,
                                                        subname: proccessVanityNumber.subnameKey
                                                    })
                                                    setLoading(false)
                                                })
                                                .catch(err => {
                                                    setLoading(false)
                                                    logFirebaseErrorEvent(err)
                                                });
                                        } else {
                                            Numbers.postProcessCommitedNumber("2")
                                                .then(response => {
                                                    setReservedNumber({ "MSISDN": response?.data?.numbers[0].MSISDN });
                                                    let proccessVanityNumber = Plans.proccessVanityNumberDataKW(
                                                        response?.data?.numbers[0].VanityLevelId
                                                    );
                                                    setReservedNumberDetail({
                                                        color: proccessVanityNumber.style_value,
                                                        vanityName: proccessVanityNumber.nameKey,
                                                        subname: proccessVanityNumber.subnameKey
                                                    })
                                                    setLoading(false)
                                                })
                                                .catch(err => {
                                                    setLoading(false)
                                                    logFirebaseErrorEvent(err)
                                                });
                                        }
                                    }
                                })
                                .catch(error => { 
                                    setLoading(false)
                                    logFirebaseErrorEvent(error)
                                })
                        }
                    }));
            })
            .catch(error => {
                setLoading(false)
                logFirebaseErrorEvent(error)
            });
    }

    const cancelDropOffJourney = () => {
        const paymentCaptureEnabled = Helpers.getStorageBooleanValue(CONSTANTS.ENABLE_PAYMENT_CAPTURE);
        
        const executeCancelFlow = () => {
            commonRecordFirebaseEvent({
                event_label: "cancel",
                interaction_type: "click",
                plan_details: planCode,
                reserved_number: reservedNumber?.MSISDN || "",
                payment_status: isPaymentPending ? "unpaid" : "paid" 
            })
            FirebaseAnalytics.button_clicked(CONSTANTS.DROP_OFF_MODAL, "ob_drop_off_cancel")
            HTTP.set_session("");
            Storage.clear("session");
            localStorage.clear();
            clearWelcomeBack();
            window.location.reload(false)
           setTimeout(() => {
            window.location.href = "/join/";
           }, 1000);
        };
        
        if (paymentCaptureEnabled && onboardingPaymentExpired) {
            if (isMnp) {
                // IsMnp FLOW
                Numbers.mnpCancel(reservedNumber?.MSISDN?.trim())
                .then(response => {
                    setLoading(false);
                    executeCancelFlow();
                })
                .catch(error => {
                    setLoading(false);
                    logFirebaseErrorEvent(error);
                    // Continue with normal cancel flow even if API fails
                    executeCancelFlow();
                });
            } else {
                // On cancel/close modal: "credit_cards/cancel_onboarding"
                setLoading(true);
                Payments.cancelOnboarding()
                    .then(response => {
                        setLoading(false);
                        executeCancelFlow();
                    })
                    .catch(error => {
                        setLoading(false);
                        logFirebaseErrorEvent(error);
                        // Continue with normal cancel flow even if API fails
                        executeCancelFlow();
                    });
            }
        } else {
            setLoading(true);
            executeCancelFlow();
        }
    }

    const continueJourney = () => {
        const paymentCaptureEnabled = Helpers.getStorageBooleanValue(CONSTANTS.ENABLE_PAYMENT_CAPTURE);
        
        const executeContinueFlow = () => {
            commonRecordFirebaseEvent({
                event_label: "continue_activation",
                interaction_type: "click",
                plan_details: planCode,
                reserved_number: reservedNumber?.MSISDN || "",
                payment_status: isPaymentPending ? "unpaid" : "paid" 
            })
            FirebaseAnalytics.button_clicked(CONSTANTS.DROP_OFF_MODAL, "ob_drop_off_continue")
            clearWelcomeBack();
            setDisplayModal(false);
            window.location.reload(false)
        };
        
        if (paymentCaptureEnabled && checkPaymentAuthentication) {
            setLoading(true);
            Payments.retryConfirmRegistration()
                .then(response => {
                    setLoading(false);
                    executeContinueFlow();
                })
                .catch(error => {
                    setLoading(false);
                    logFirebaseErrorEvent(error);
                });
        } else {
            executeContinueFlow();
        }
    }

    const clearWelcomeBack = () => {
        localStorage.removeItem("WelcomeBack");
        localStorage.removeItem("ReloadedOrLeft");
        localStorage.removeItem("PageReloaded");
        localStorage.removeItem("TabSwitched");
        sessionStorage.removeItem("TabSwitchedBack");
    }

    useEffect(() => {
        getSummaryDetail();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const getSummaryDetail = () => {
        setSummaryLoading(true);
        Summaries.getSummary()
            .then((res) => {
                if (res?.data) {
                    const savedPlanBundle = res?.data?.saved_plans[0];
                    setSavedPlanBundle(savedPlanBundle ?? null);
                    setSavedPlans(savedPlanBundle?.Plans || []);
                    setPlanPromotions(savedPlanBundle?.PlanPromotions || []);
                    setPlanCode(savedPlanBundle?.PlanCode || "");
                    setPlanPrice(savedPlanBundle?.DiscountedPrice ?? 0);
                    setPlanId(savedPlanBundle?.ID != null ? savedPlanBundle.ID : null);
                    setPlanDiscountedPrice(savedPlanBundle?.DiscountedPrice ?? null);
                    setFeatureAttributes(savedPlanBundle?.FeatureAttributes || []);
                    commonRecordFirebaseEvent({
                        interaction_type: "view",
                        plan_details: savedPlanBundle?.PlanCode,
                        reserved_number: Storage.get('number') || ""
                    })
                }
                setSummaryLoading(false);
            })
            .catch(() => {
                setSummaryLoading(false);
            });
    }


    const {addonsValues, dataBonusValues, minutesBonusValues, smsBonusValues} = useMemo(()=>{
        const freeAddons = []
        const dataBonus = []
        const minutesBonus = []
        const smsBonus = []
        const freePlanPromotions = planPromotions?.filter(promotion => promotion["Type"] === variables.PROMOTION_TYPE_FREE_PLAN);
        for (let promotion of freePlanPromotions) {
          const parsed = JSON.parse(promotion["Value"]);
          switch (parsed.Type) {
            case variables.PROMOTION_TYPE_VOICE_ON_NET:
            case variables.PROMOTION_TYPE_DATA_SOCIAL:
              freeAddons.push(parsed);
              break;
            case variables.PROMOTION_TYPE_DATA:
              dataBonus.push(parsed);
              break;
            case variables.PROMOTION_TYPE_VOICE_LCL:
              minutesBonus.push(parsed);
              break;
            case variables.PROMOTION_TYPE_SMS:
              smsBonus.push(parsed);
              break;
            default:
          }
        }
      
        for (let plans of savedPlans) {
          if(plans?.Type === variables.PROMOTION_TYPE_DATA_SOCIAL) {
            freeAddons.push({Type: plans?.Type, Value: plans?.Value});
          }
        }
        
        let dataBonusValues = Plans.getSumData(dataBonus, variables.PROMOTION_TYPE_DATA, "gb");
        let minutesBonusValues = Plans.getSumData(minutesBonus, variables.PROMOTION_TYPE_VOICE_LCL, "min");
        let smsBonusValues = Plans.getSumData(smsBonus, variables.PROMOTION_TYPE_SMS, "sms");
        let addonsValues = Plans.getSumData(freeAddons, variables.PROMOTION_TYPE_DATA_SOCIAL, "gb")
      
        return {addonsValues, dataBonusValues, minutesBonusValues, smsBonusValues}
    },[planPromotions, savedPlans])

    const showAmanSummaryFeatureRows = useMemo(() => {
        const attrs = resolveAmanFeatureAttributes({ planCode, planId, selectedCard: null });
        return hasAmanFeatureSummaryAttributeData(attrs);
    }, [planCode, planId]);

    const amanPlanHeaderTitle = useMemo(() => {
        if (!showAmanSummaryFeatureRows || !planCode) {
            return "";
        }
        const planCodeNorm = planCode
            .replaceAll("-", "_")
            .replaceAll(" ", "")
            .replaceAll(",", "")
            .toLowerCase();
        const nameKey = `general_plan_name_${planCodeNorm}`;
        return (
            translationsKeys[nameKey] ||
            planCode ||
            translationsKeys["general_plan_custom"] ||
            ""
        );
    }, [showAmanSummaryFeatureRows, planCode, translationsKeys]);
    const egyptFlexSummarySource = useMemo(
        () => Helpers.resolveEgyptFlexSummarySource(savedPlanBundle, planPrice),
        [savedPlanBundle, planPrice]
    );

    const renderPlanDetailsAll = (plan) => {
        let content = null;
        let flagZero = 0;
        if (plan?.Unit === "sms") {
          // FOR "SMS-LCL"
          if (plan?.Value === -1 || smsBonusValues < 0) {
            flagZero = 1;
            content = <>
                {Translations.keys["free_addons_unlimited"]}{" "}
              <span className="unit">{Translations.keys[prefix_general + "sms_unit"]}</span>
            </>;
          } else {
            if (smsBonusValues > 0) {
              flagZero = 1;
              content = <>
                <span>{`(${storefront.getPlanDataMinValue(plan?.Value, plan?.Type)} + ${smsBonusValues}) = ${storefront.getPlanDataMinValue(plan?.Value, plan?.Type) + smsBonusValues}`}{" "}</span>
                <span className="unit">{Translations.keys[prefix_general + "sms_unit"]}</span>
              </>;
            } else {
              flagZero = storefront.getPlanDataMinValue(plan?.Value, plan?.Type);
              content = <>
                <span>{storefront.getPlanDataMinValue(plan?.Value, plan?.Type)}{" "}</span>
                <span className="unit">{Translations.keys[prefix_general + "sms_unit"]}</span>
              </>;
            }
          }
        }
    
        if (plan?.Unit === "bytes") {
          // FOR "DATA" & "DATA-SOCIAL"
          if (plan?.Value === -1 || dataBonusValues < 0) {
            flagZero = 1;
            content = <>
              {Translations.keys["free_addons_unlimited"]}{" "}
              <span className="unit">{Translations.keys[prefix_general + "data_unit"]}</span>
            </>;
          } else {
            if (dataBonusValues > 0) {
              flagZero = 1;
              content = <>
                <span>{`(${storefront.getPlanDataMinValue(plan?.Value, plan?.Type)} + ${dataBonusValues}) = ${storefront.getPlanDataMinValue(plan?.Value, plan?.Type) + dataBonusValues}`}{" "}</span>
                <span className="unit">{Translations.keys[prefix_general + "data_unit"]}</span>
              </>;
            } else {
              flagZero = storefront.getPlanDataMinValue(plan?.Value, plan?.Type);
              content = <>
                <span>{storefront.getPlanDataMinValue(plan?.Value, plan?.Type)}{" "}</span>
                <span className="unit">{Translations.keys[prefix_general + "data_unit"]}</span>
              </>;
            }
          }
        }
    
        if (plan?.Unit === "milliseconds") {
          // For "VOICE-LCL"
          if (plan?.Value === -1 || minutesBonusValues < 0) {
            flagZero = 1;
            content = <>
              {Translations.keys["free_addons_unlimited"]}{" "}
              <span className="unit">{Translations.keys[prefix_general + "minute_unit"]}</span>
            </>;
          } else {
            if (minutesBonusValues > 0) {
              flagZero = 1;
              content = <>
                <span>{`(${storefront.getPlanDataMinValue(plan?.Value, plan?.Type)} + ${minutesBonusValues}) = ${storefront.getPlanDataMinValue(plan?.Value, plan?.Type) + minutesBonusValues}`}{" "}</span>
                <span className="unit">{Translations.keys[prefix_general + "minute_unit"]}</span>
              </>;
            } else {
              flagZero = storefront.getPlanDataMinValue(plan?.Value, plan?.Type);
              content = <>
                <span>{storefront.getPlanDataMinValue(plan?.Value, plan?.Type)}{" "}</span>
                <span className="unit">{Translations.keys[prefix_general + "minute_unit"]}</span>
              </>;
            }
          }
        }
        const planValueObj = {
          content: content,
          flagZero: flagZero
        } 
        return planValueObj;
    }

    const commonRecordFirebaseEvent = ({ event_label = "", interaction_type = "", ...properties }) => {
        const event_params = {
          event_category: "storefront",
          event_screen: "welcome_back_activation",
          event_label,
          interaction_type,
          ...properties
        }
        FirebaseAnalytics.commonFunction(event_params)
    }

    const logFirebaseErrorEvent = (error) => { 
        commonRecordFirebaseEvent({
            event_label: "error",
            interaction_type: "view",
            error_code: error?.data?.code
        })
    }

    return (<>
        {displayModal && <div className="dialog dialog-ob-modal">
            <div className="dialog-modal-container-ob drop-odd-modal">
                {loading || summaryLoading || !translationsKeys["stm_sum_your_number"] ? <SpinnerTimeLoader /> :
                    <>
                        <div className='ob-modal-title'>
                            {translationsKeys["ob_drop_off_welcome_back"]}
                            <button
                                className="close-icon"
                                onClick={cancelDropOffJourney}
                            />
                        </div>
                        <div className='ob-modal-subtitle'>
                            {translationsKeys["ob_drop_off_welcome_back_msg"]}
                        </div>

                        <div className="ob-modal-active-service">
                            {reservedNumber?.MSISDN &&
                            <div className="stm-sum-wrapper">
                                <div className='stm-act-card'>
                                    <div className="stm-act-logo">
                                        <img src={Call} alt="call" />
                                        <span>
                                            {translationsKeys["stm_sum_your_number"]}</span>
                                    </div>
                                    <div className='stm-act-grid'>
                                        <div className="stm-act-block-left">
                                            {translationsKeys[`general_vanity_name_${reservedNumber.VanityLevelId}number`]}
                                        </div>
                                        <div className="stm-act-block-right">
                                            {Numbers.get_number_pieces(reservedNumber.MSISDN, reservedNumber.VanityLevelId, null, {})}
                                        </div>
                                    </div>
                                </div>
                            </div>}
                            <div className='stm-sum-wrapper drop-off-modal-plan'>
                                <div className='stm-act-card'>
                                    {egyptFlexSummarySource ? (
                                        <EgyptFlexSummaryPlan
                                            plan={egyptFlexSummarySource.plan}
                                            price={egyptFlexSummarySource.price}
                                        />
                                    ) : (
                                        <>
                                            {showAmanSummaryFeatureRows ? (
                                                <div
                                                    className={
                                                        "stm-act-logo" +
                                                        (planDiscountedPrice != null
                                                            ? " stm-act-logo--plan-with-price"
                                                            : "")
                                                    }
                                                >
                                                    <div className="stm-act-logo__main">
                                                        <img src={Data} alt="" />
                                                        <span>
                                                            {amanPlanHeaderTitle
                                                                ? Helpers.nextLineText(amanPlanHeaderTitle, "span")
                                                                : translationsKeys["scr_3.10_A_signup_step_plan_name"]}
                                                        </span>
                                                    </div>
                                                    {planDiscountedPrice != null ? (
                                                        <span className="stm-act-logo__price">
                                                            {planDiscountedPrice}{" "}
                                                            {translationsKeys[prefix_general + "currency"]}
                                                        </span>
                                                    ) : null}
                                                </div>
                                            ) : (
                                                <div className="stm-act-logo">
                                                    <img src={Data} alt="" />
                                                    <span>
                                                        {translationsKeys["scr_3.10_A_signup_step_plan_name"]}
                                                    </span>
                                                </div>
                                            )}
                                            <div className="stm-act-grid">
                                                {savedPlans?.map((plan) => {
                                                    const contentService = Helpers.getStreaminService();
                                                    if(plan?.Type !== variables.PROMOTION_TYPE_DATA_SOCIAL &&
                                                        !contentService?.includes(plan?.Type?.toLowerCase())
                                                    ) {
                                                    return(
                                                        renderPlanDetailsAll(plan)?.flagZero > 0 ?
                                                        <React.Fragment key={plan.ID}>
                                                            <div className="stm-act-block-left">
                                                                {Translations.keys[prefix_general + plan?.Type.replaceAll("-", "_").replaceAll(" ", "").toLowerCase()] ? Translations.keys[prefix_general + plan?.Type.replaceAll("-", "_").replaceAll(" ", "").toLowerCase()] : plan?.Type}
                                                            </div>
                                                            <div className="stm-act-block-right">
                                                                {renderPlanDetailsAll(plan)?.content}
                                                            </div>
                                                        </React.Fragment> : ""
                                                    )
                                                    } else {
                                                    return ""
                                                    }
                                                })}
                                                {addonsValues !== 0 &&
                                                <>
                                                    <div className="stm-act-block-left">
                                                    {Translations.keys['stm_general_data_social']}
                                                    </div>
                                                    <div className="stm-act-block-right">
                                                    {addonsValues === -1 ? Translations.keys["free_addons_unlimited"] : addonsValues}{" "}<span className="unit">{Translations.keys[prefix_general + "data_unit"]}</span>
                                                    </div>
                                                </>}
                                                {showAmanSummaryFeatureRows ? (
                                                    <StmSummaryAmanFeatureRows
                                                        planCode={planCode}
                                                        planId={planId}
                                                        featureAttributes={featureAttributes}
                                                    />
                                                ) : null}
                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>
                            <div className="ob-modal-action-button">
                                <button className="common-button" onClick={continueJourney}>{translationsKeys["3.3.2.B_btn_continue"]}</button>
                                <div className="common-button-text" onClick={cancelDropOffJourney}>{translationsKeys["stf_cancel"]}</div>
                            </div>
                        </div>
                    </>}
            </div>
        </div>}
    </>
    )
}

export default DropOffModal;